import React, { ComponentProps } from 'react'

import { Stack, XStack } from '@zet/design-system'
import { Button } from '@zet/design-system/button'
import { Control, useFormState } from 'react-hook-form'

import { ICON_MAP } from '../../utils/iconMap'

interface Props {
  step?: {
    total: number
    current: number
  }
  buttonProps?: ComponentProps<typeof Button>
  control: Control
}

const FormButton = (props: Props) => {
  const {
    control,
    buttonProps,
    step,
    buttonProps: { title, icon },
  } = props

  const { isValid } = useFormState({
    control,
  })
  const ICON = ICON_MAP[icon || '']

  return (
    <Button
      size="lg"
      disabled={!isValid || buttonProps?.disabled}
      fullWidth
      onPress={buttonProps?.onPress}
      loading={buttonProps?.loading}
    >
      <XStack className="items-center justify-center self-center">
        {icon && ICON && (
          <Stack className="mr-2">
            <ICON />
          </Stack>
        )}
        {title ? title : step?.current === step?.total ? 'Submit' : 'Continue'}
      </XStack>
    </Button>
  )
}

export default FormButton
